import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, FlatButton } from 'material-ui'
import styles from './styles/ExpandedMediaModal.css'

const DiscardMessageDialog = ({ pendingConvoId, onClose, onSubmit }) => (
  <Dialog
    open={!!pendingConvoId}
    onRequestClose={onClose}
    contentStyle={{ width: '600px' }}
    zDepth={10}
  >
    <div className={styles.popOverContainer}>
      <h3>Are you sure you would like to discard this message?</h3>
      <h5>Navigating to another conversation will discard this draft.</h5>
      <div className={styles.popOverButton}>
        <FlatButton label="Cancel" secondary onClick={onClose} />
        <FlatButton
          label="Discard"
          primary
          onClick={() => onSubmit(pendingConvoId)}
        />
      </div>
    </div>
  </Dialog>
)

DiscardMessageDialog.propTypes = {
  pendingConvoId: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default DiscardMessageDialog



// WEBPACK FOOTER //
// ./src/components/Messages/DiscardMessageDialog.js